<template>
  <div class="web-content-option">
    <a
      :href="url"
      aria-labelledby="info-text"
      class="link-button"
      rel="noopener noreferrer"
      @click="handleWebContentClick">
      <oie-base-icon
        icon="launch"
        size="xs"></oie-base-icon>
      {{ title }}
    </a>
  </div>
</template>

<script>
import gtm from '@/core/enhanced-ecommerce-gtm'

export default {
  props: {
    sessionId: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    url: {
      type: String,
      required: true
    }
  },
  methods: {
    handleWebContentClick(event) {
      event.preventDefault()
      gtm.chatWebContentClick(this.url, this.sessionId)
      window.open(this.url, '_self')
    }
  }
}
</script>

<style scoped>
.web-content-option {
  margin-top: 10px;
  border-radius: 4px;
  border: 1px solid #ccc;
}

.web-content-option:hover {
  border: 1px solid rgba(0, 91, 187, 0.15);
}

.link-button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  padding: 6px 14px;
  color: #005BBB;
  border-radius: 4px;
  text-decoration: none;
  font-weight: 500;
  background-color: transparent;
  transition: all 0.2s ease;
}

.link-button:hover {
  background-color: rgba(0, 91, 187, 0.15);
}
</style>
